module.exports =
  '_SESSION':
    'NEW':
      'TITLE': '@:_SESSION.NEW.SIGN_IN'
      'SIGN_IN': 'Sign in'
      'LOCK_ACCOUNT': 'Login attempt is locked because of protecting the account. Try later again.'
      'EMAIL_ADDR': 'Email Address'
      'PASSWORD': 'Password'
      'FORGOT_PASSWORD': 'Forgot password?'
      'LOGIN_GUIDE': 'You can use the log-in account from YOUR GOLF and
        <br>GOLF NETWORK PLUS Applications.
        <br>It is used for both the application and website.'
      'LOGIN_GUIDE_TINY': 'You can use the log-in account from YOUR GOLF
        <br>and GOLF NETWORK PLUS Applications.
        <br>It is used for both the application and website.'
      'ERROR': 'The email and password you entered did not match. Please check and try again.'
      'SIGN_UP_SUP': 'If you are a first time visitor, please sign up from here.'
      'SIGN_UP_SUP_TINY': 'If you are a first time visitor
        <br>please sign up from here.'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/session/i18n/en.coffee